import { render, staticRenderFns } from "./callKnowlarity.vue?vue&type=template&id=c44c09e6&"
import script from "./callKnowlarity.vue?vue&type=script&lang=js&"
export * from "./callKnowlarity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports